const {
  PasswordChange
} = svs.retail.PasswordChange;
const ForcePasswordChange = () => {
  const handleCancelButtonClick = () => {
    window.location = svs.core.urlMapping.get('logout');
  };
  return <PasswordChange desc="Ditt engångslösenord behöver bytas till ett som du själv väljer." onCancel={handleCancelButtonClick} title="Du behöver byta lösenord" />;
};
export default ForcePasswordChange;